<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>
          {{ editaronlyPunto ? 'CambiarPunto de venta' : 'Asignar Sede a la Sucursal' }}
        </v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-select
              :readonly="editaronlyPunto"
              label="* Sede"
              v-model="asignar.sede_id"
              :items="sedes"
              item-value="id"
              item-text="nombre"
              :loading="loadingsedes"
              dense
              outlined
              color="green"
            ></v-select>
            <v-select
              label="Punto de venta"
              v-model="asignar.punto_venta_id"
              :items="puntos"
              item-value="id"
              :loading="loadingpuntos"
              dense
              color="green"
              outlined
              clearable
            ></v-select>
          </v-container>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save()" class="green darken-2" dark :disabled="loading">
            {{ editaronlyPunto ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loadingsedes: false,
        loadingpuntos: false,
        msg: '',
        puntos: [],
        sedes: [],
        editaronlyPunto: false,
        asignar: {
          id: null,
          sede_id: null,
          sucursal_id: null,
          punto_venta_id: null,
        },
      };
    },
    components: {},
    watch: {},
    methods: {
      async openmodal(item, editaronlyPunto = false) {
        window.console.log('>>', item);
        this.msg = '';
        this.dialog = true;
        this.asignar.id = null;
        this.asignar.sede_id = null;

        this.asignar.punto_venta_id = null;
        this.asignar.sucursal_id = item.id;

        this.editaronlyPunto = editaronlyPunto;
        this.getpuntosv(item.id);
        if (item.punto_venta_id != null) {
          this.asignar.punto_venta_id = item.punto_venta_id;
        }
        if (editaronlyPunto) {
          this.asignar.sede_id = item.sede.id;
          this.asignar.id = item.idsedesucursal;
        }
        this.sedes = await this.getSedes();
        this.loadingsedes = false;
        window.console.log(item, this.sedes);
      },
      getSedes() {
        this.loadingsedes = true;
        const qs = gql`query ${''} { getSedes { id nombre direccion }}`;
        return this.$apollo
          .query({ query: qs })
          .then(({ data }) => (data.getSedes ? data.getSedes : []))
          .catch(() => []);
      },
      getpuntosv(idsucursal) {
        this.puntos = [];
        let vue = this;
        vue.loadingpuntos = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas?sucursalId=${idsucursal}`,
          headers: {
            //apikey: '4265269017',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log('puntos:', data);
            data.map((x) => {
              x.text = `[${x.codigo_punto_venta}] ${x.nombre} (${x.descripcion})`;
            });
            vue.puntos = data;
            vue.loadingpuntos = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingpuntos = false;
          });
      },
      save() {
        this.msg = '';
        //if (!this.asignar.punto_venta_id) this.msg = 'Seleccione un punto de venta.';
        if (!this.asignar.sede_id) this.msg = 'Seleccione una sede.';

        if (this.msg) return;

        this.loading = true;
        let metodo = 'post';
        if (this.asignar.id) metodo = 'put';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales`,
          headers: {
            'Content-Type': 'application/json',
            //apikey: '4265269017',
          },
          data: this.asignar,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            if (data) {
              vue.msg = data;
              vue.$emit('newregasignar', data);
            }
            window.console.log('asignarnew::', data);
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
  };
</script>
